import moment from 'moment';

export function getDatepickerDateOptions(shipping_date) {
    console.log("getDatepickerDateOptions called")
    console.log(shipping_date)
    // Set up min/max days

    let minDate = new Date();

    // Create Feb 10th, 2025 date to compare against
    const feb10 = new Date();
    feb10.setDate(10);
    feb10.setMonth(1); // February
    feb10.setFullYear(2025);

    // Create date 3 days from now
    const threeDaysOut = new Date();
    threeDaysOut.setDate(threeDaysOut.getDate() + 3);

    // If we're more than 3 days before Feb 10th, use Feb 10th
    // Otherwise use 3 days from now
    if (threeDaysOut < feb10) {
        console.log("Setting mindate to Feb 10th")
        minDate.setDate(10);
        minDate.setMonth(1); // February
        minDate.setFullYear(2025);
    } else {
        console.log("Setting mindate to 3 days from now")
        minDate.setDate(threeDaysOut.getDate());
        minDate.setMonth(threeDaysOut.getMonth());
        minDate.setFullYear(threeDaysOut.getFullYear());
    }

    // TODO! If on a certain date at the end of the week, add a day?

    let maxDate = new Date();
    maxDate.setDate(7)
    maxDate.setMonth(2) // March
    maxDate.setFullYear(2025)

    // TODO: Conditionally set min day based on current day (3 days out, complex logic)

    // Set the currently set date or default date to first available date
    let defaultDate = minDate;
    let setDefaultDate = false;
    if (shipping_date) {
        // TODO: turn 'yyyy-mm-dd' into Date object
        defaultDate = new Date()
        const dateParts = shipping_date.split('-')
        defaultDate.setFullYear(dateParts[0]);
        // VERY IMPORTANT to set the date first!
        // Otherwise it may push forward to the next month if the date doesn't exist in the new month (e.g. Feb 29th)
        defaultDate.setDate(dateParts[2]);
        defaultDate.setMonth(dateParts[1] - 1);
        setDefaultDate = true
        console.log("Setting default date to " + shipping_date)
        // console.log(shipping_date)
        // console.log(defaultDate)
    }

    const options = {
        minDate,
        maxDate,
        defaultDate,
        setDefaultDate
    };
    console.log("getDatepickerDateOptions response")
    console.log(options)

    return options
}

/*
  Displayed format example: Jan 1, 2021
  https://momentjs.com/docs/#/displaying/
*/
export function formatDateForDisplay(dateObject) {
    return moment(dateObject).format("MMM D, YYYY");
}


export default {
    getDatepickerDateOptions,
    formatDateForDisplay
}
